/* eslint-disable eqeqeq */
/* eslint-disable no-console */
import React from "react";
import LabelAndValue from "./LabelAndValue";
import { FinanceHoverIcon } from "../../../Common/Svgs/FinanceIcon";
import BatteriesAssigned from "./BatteriesAssigned";
import { RENTAL_STATUS } from "../constant";

const EnergyConsumption = ({ details }) => {
  const getTotalEnergyFee = () => {
    if (details?.status == RENTAL_STATUS.ONGOING) return "--";
    if (!details?.batteries?.length) return "--";

    const batteryCost = details?.batteries?.reduce((acc, current) => {
      const energy =
        parseFloat(current?.startEnergy || 0) -
        parseFloat(current?.endEnergy || 0);

      const cost = energy * parseFloat(current?.rate || 0);

      acc += cost;
      return acc;
    }, 0);

    return batteryCost ? `${parseFloat(batteryCost).toFixed(0)} KSH` : "--";
  };

  const getEnergyConsumed = () => {
    if (details?.status == RENTAL_STATUS.ONGOING) return "--";
    if (!details?.batteries?.length) return "--";

    const start = details?.batteries?.reduce((acc, current) => {
      acc += parseFloat(current?.startEnergy || 0);
      return acc;
    }, 0);

    const end = details?.batteries?.reduce((acc, current) => {
      acc += parseFloat(current?.endEnergy || 0);
      return acc;
    }, 0);

    const consumed = parseFloat(start) - parseFloat(end);
    return consumed ? `${consumed.toFixed(1)} kWh` : "--";
  };

  const getAmountCharged = () => {
    if (details?.status == RENTAL_STATUS.ONGOING) return "--";
    if (!details?.batteries?.length) return "--";

    const amount = details.batteries.reduce((acc, current) => {
      acc += parseFloat(current?.rate || 0);
      return acc;
    }, 0);

    const avg = amount / details.batteries.length;

    return amount ? `${avg.toFixed(0)} KSH/Wh` : "--";
  };

  return (
    <div className="bg-background-white p-4 h-[202px] border-[0.5px] border-light-grey rounded-md">
      <div className="flex items-center gap-x-2.5">
        <div className="w-[38px] h-[38px] flex items-center justify-center rounded-full bg-primary">
          <FinanceHoverIcon size={16} className="text-background-white" />
        </div>

        <p className="font-poppins font-medium text-base">Energy Consumption</p>
      </div>

      <div className="ml-12 flex items-center gap-x-[82px]">
        <LabelAndValue label="Total energy fee" value={getTotalEnergyFee()} />

        <BatteriesAssigned
          batteries={details?.batteries?.length ? details.batteries : []}
        />

        <LabelAndValue
          label="Total energy consumed"
          value={getEnergyConsumed()}
        />
      </div>

      <div className="ml-12 mt-6">
        <LabelAndValue label="Amount/Wh" value={getAmountCharged()} />
      </div>
    </div>
  );
};

export default EnergyConsumption;
